import React, { useState, useEffect} from 'react';
import { connect } from "react-redux";
import * as createActions from "../../actions/createTrial.js";
import {withRouter } from 'react-router';
import { Row, Col, Tooltip, Button, Badge, Collapse, message,} from "antd";
import "./index.scss";
import ReactECharts from 'echarts-for-react';
import { PlusCircleOutlined, CarryOutFilled, MinusOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import EditEndpointsTable from '../EditEndpointsTable';
import EndpointDetails from "../EndpointDetails";
import { getTrialEndpoints, getEndpointLibrary, saveEndpoints } from '../../utils/ajax-proxy';
import { getEmail } from "../../utils/auth";
import {  formatWithCommas, roundToWholeNumber} from '../../utils/utils';
const { Panel } = Collapse;


const initialChartData = [
  {
    "chart_type": "Patient burden", 
    "Primary":0,
    "Secondary":0,
    "Exploratory":0,
  },
  {
    "chart_type": "Cost", 
    "Primary":0,
    "Secondary":0,
    "Exploratory":0,
  }
]

const initialGlanceData = {
  endpoint_at_glance: {
    primary_endpoint_hist: 0,
    primary_endpoint_scenario: 0,
    secondary_endpoint_hist: 0,
    secondary_endpoint_scenario: 0,
    unique_primary_endpoint_hist: 0,
    unique_count_primary_endpoint: 0,
    unique_secondary_endpoint_hist: 0,
    unique_count_secondary_endpoint: 0,
  }
}

const EndpointsLibrary = (props) => {

  const {
    readOnly
  } = props
  const [endPointsActiveKey, setEndpointsActiveKey] = useState(() => {
      const storedData = JSON.parse(localStorage.getItem('collapseCharts'));
      return storedData ? storedData.endpointCollapse : ['1'];
    });
  const [costByEndpointType, setCostByEndpointType] = useState(props.newEndpoint.trialEndpointData?.pb_cost_metrics?props.newEndpoint.trialEndpointData.pb_cost_metrics:initialChartData);
  const [EndpointByAtGlance, setEndpointByAtGlance] = useState(props.newEndpoint.trialEndpointData?.endpoint_at_glance?props.newEndpoint.trialEndpointData:initialGlanceData);

  function endpointsCallback(key) {
    const storedData = JSON.parse(localStorage.getItem('collapseCharts'));
    if (storedData) {
     storedData.endpointCollapse = key;
     const updatedDataString = JSON.stringify(storedData);
     localStorage.setItem('collapseCharts', updatedDataString);
    } else{
      localStorage.setItem('collapseCharts', JSON.stringify({"endpointCollapse" : key,
                                                "inclusionCollapse" : ['1'],
                                                "exclusionCollapse" : ['1'],
                                                "soaCollapse" : ['1']
                                                }));
    }
    setEndpointsActiveKey(key)
  }

  useEffect(() => { 
    setEndpointsActiveKey(endPointsActiveKey)
  }, [endPointsActiveKey]);

  const [endpointOrg, setEndpointOrg] = useState([]);
  const [endpointAdded, setEndpointAdded] = useState([])
  const [eventPanel, setEventPanel] = useState("1") 
  const [eventLib, setEventLib] = useState(6)
  const [dismissEvent, setDismissEvent] = useState([])
  const [insightEvent, setInsightEvent] = useState(props.newEndpoint.endpointInsightEvent? props.newEndpoint.endpointInsightEvent:[]) 
  const [endpointPanelStatus, setEndpointPanelStatus] = useState(false)

  const costEndpointOption =  {
    tooltip: {
      trigger: 'item',
      formatter: (params) => Math.round(params.value * 1000) / 10 + '%',
    },
    legend: {
      show:true,
      right: 0,
      orient: "vertical",
      top: "27%",
      align: "auto",
      itemWidth: 10,
      itemHeight: 10,
      data: [
        {name: 'Primary', icon: 'circle'},
        {name: 'Secondary', icon: 'circle'},
        {name: 'Exploratory', icon: 'circle'}
      ],
    },
    grid: {
      top: '3%',
      left: '3%',
      right: '20%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
      splitLine: {
        // show: false,
      },
      axisLabel: {
        show: true,
        formatter: (params) => Math.round(params * 1000) / 10 + '%',
      },
    },
    yAxis: {
      type: 'category',
      inverse: true,
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      data: costByEndpointType&&costByEndpointType.map(item => item.chart_type)
    },
    series: [
      {
        name: 'Primary',
        type: 'bar',
        stack: 'total',
        color: '#D04A02',
        barMaxWidth: 45,
        data: (costByEndpointType && costByEndpointType.map(item => item.Primary)) || []
      },
      {
        name: 'Secondary',
        type: 'bar',
        stack: 'total',
        color: '#EB8C00',
        label: {
          show: false
        },
        barMaxWidth: 45,
        data: (costByEndpointType && costByEndpointType.map(item => item.Secondary)) || []
      },  
      {
        name: 'Exploratory',
        type: 'bar',
        stack: 'total',
        color: '#FFB600',
        label: {
          show: false
        },
        barMaxWidth: 45,
        data: (costByEndpointType&&costByEndpointType.map(item => item.Exploratory))||[]
      },   
    ]
  }

  const fetchData = async () => {
    try { 
      const trial_uuid = localStorage.getItem('trial-id')
      const scenario_id = localStorage.getItem('ts_id') 
      const user_name = getEmail()
      const response = await getTrialEndpoints(trial_uuid, scenario_id, user_name);  

      if(response) {  
        const exploratory = response['exploratory']
        const primary = response['primary']
        const secondary = response['secondary'] 
        const insight = response['endpoint_insights']
        props.updateEndpoints({ 
         endpointAdded: [...exploratory, ...primary, ...secondary],
         endpointInsightEvent:[...insight],
         trialEndpointData:response,
        }) 
        setInsightEvent(insight?insight:[])
        setEndpointAdded([...exploratory, ...primary, ...secondary])
        setCostByEndpointType(response['pb_cost_metrics']?response['pb_cost_metrics']:initialChartData)
        setEndpointByAtGlance(response['endpoint_at_glance']?response:initialGlanceData)
      }
    } catch (error) { 
    }
  };

  useEffect(() => {
    const resetAndFetchData = async () => {
      if (props?.newEndpoint?.endpointAdded?.length > 0) {
        // Clear endpointAdded
        await props.updateEndpoints({
          ...props.newEndpoint,
          endpointAdded: [],
        });
        await fetchData();
      } else if (props?.newEndpoint?.endpointAdded?.length === 0) {
        await fetchData();
      }
    };
  
    resetAndFetchData();
    // Auto-save endpoints when navigating from the ADD page
    autoSave();
  }, []);

  const endpointInsightsToggleHandler = (status) => {
    setEndpointPanelStatus(status);
    setEventLib(!status ? 0 : 6)
  }

  const filterAddedInsights = (insights) => insights.filter((insight) => {
    // No need to filter the repeated insights
    // if ( insight.action === "ADD") {
    //   return !!!endpointAdded.find(item => item['endpoint_std_term'] === insight.endpoint_std_term);
    // }

    // if (insight.action === "REMOVE") {
    //   return !!endpointAdded.find(item => item['endpoint_std_term'] === insight.endpoint_std_term);
    // }
    return true;
  });

 
  const fetchEndpointLibrary = async () => {
    try {
      const response = await getEndpointLibrary(props.trial_id, props.scenarioId); 
      if(response&&response.endpoints){        
        setEndpointOrg(response.endpoints)
        props.updateEndpoints({
          endpointOrg: response.endpoints,           
        }) 
      }
    } catch (error) { 
    }
  };

  useEffect(() => {
    fetchEndpointLibrary()
    autoSave()
  }, []);


  const showEndpointPage = () => {
    props.history.push({
      pathname: '/add-endpoint',
      state: {
        similarHistoricalTrials: props.similarHistoricalTrials,
        trial_id: props.trial_id,
        scenarioId: props.scenarioId, 
        scenarioType: props.scenarioType,
        readOnly: readOnly,
        endpointOrg: endpointOrg?.length>0?endpointOrg:props.newEndpoint?.endpointOrg,
        endpointAdded: props.newEndpoint.endpointAdded
       }
     })
  }

  const removeInsightEvent = (key) => {
    let rawInsight = [...insightEvent]    
    rawInsight = rawInsight.filter((d) => {
     return !(d.endpoint_type === key.endpoint_type 
      && d.endpoint_id === key.endpoint_id 
      && d.insight_type === key.insight_type)
    })
    setInsightEvent(rawInsight)
    props.updateEndpoints({ endpointInsightEvent: rawInsight })
  }

  const onInsightClick = (item) => {  
    let resData
    const handleInsightChange = (orgCategoryData, addedCategoryData) => {
      let newSelectedData 
      if (addedCategoryData.length === 0) {
        newSelectedData = props?.newEndpoint?.endpointAdded.filter((d) => !(d.endpoint_type === item.endpoint_type && d.endpoint_id === item.endpoint_id));
      } else {
          newSelectedData = [...addedCategoryData].filter((d) => !(d.endpoint_type === item.endpoint_type && d.endpoint_id === item.endpoint_id));
      }     
      return {newSelectedData}
    }

    if(item.action === "REMOVE"){
      resData = handleInsightChange(endpointOrg, endpointAdded)
      setEndpointAdded(resData.newSelectedData)
      props.updateEndpoints({
        endpointAdded: resData.newSelectedData, 
      });
      removeInsightEvent(item)
    } else {
      setAddActivityModal(true)
      let record = endpointOrg.find((d) => {
        return d.endpoint_std_term === item.endpoint_std_term 
         && d.endpoint_id === item.endpoint_id
       })
     setSelectedActivity({...record}) 
     setAddInsightsItem(item)
    }
    
  }

  const onDismiss = (key) => {   
    let rawList = [...dismissEvent]
    rawList.push(key)
    setDismissEvent(rawList)
    props.updateEndpoints({endpointDismissEvent: rawList})    
    removeInsightEvent(key)
  }

  useEffect(() => {  
    const fetchData = async () => {  
      if (props.submitType === 4) {  
        saveEndpoint(undefined, true);
      }  
    };  
    
    fetchData();  
  }, [props.submitType]);  
  

  const saveEndpoint = async (e?, whetherNav = false) => {
   localStorage.setItem('whetherSaveEndpoint', '')
   const modality = [
    {"key":1,"name":"eSource & wearables","color":"#FFBF00"},
    {"key":2,"name":"Telemedicine","color":"#75C716"},
    {"key":3,"name":"Home health","color":"#C9DF00"},
    {"key":4,"name":"Local lab & sample collection","color":"#6A86FA"},
    {"key":5,"name":"Local clinic", "color":"#FF025F"},
    {"key":6,"name":"IP direct shipment", "color":"#83B1FA"},
    {"key":7,"name":"eConsent","color":"#00A760"},
    {"key":8,"name":"Traditional site","color":"#CB0047"}]
    
    const payload = {
      "ts_id": Number(localStorage.getItem('ts_id')),
      "primary": props?.newEndpoint?.endpointAdded.filter( item => item.endpoint_type === 'Primary'),
      "secondary":props?.newEndpoint?.endpointAdded.filter( item => item.endpoint_type === 'Secondary'),
      "exploratory":props?.newEndpoint?.endpointAdded.filter( item => item.endpoint_type === 'Exploratory'),
      "modality_options": modality,
      "endpoint_dismissed_list": props?.newEndpoint?.endpointDismissEvent,
    }
    
    const resp = await saveEndpoints(payload);
    
    if (resp && resp.statusCode === 200) {
      if (props.submitType !== 4) {
        fetchData()
      }
      message.success("Save successfully");
      whetherNav&&props.navigateToMtw()
      // Clear the value of endpointDismissEvent after saving
      props.updateEndpoints({endpointDismissEvent: []}) 
      setDismissEvent([])
    }else{
      message.error("Failed to save");
    }
  }

  const autoSave = async () => {
    if(localStorage.getItem('whetherSaveEndpoint')) {
      saveEndpoint()
    }else {
      // setPageLoading(false)
    }
  }

  const initialEndpoint = {
    "endpoint_std_term": "",
    "endpoint_category": "",
    "primary_frequency": null,
    "secondary_frequency": null,
    "endpoint_id": null,
    "cost": null,
    "endpoint_type": 'Primary',
    "modality": [],
    "usage_data" : [],
    "hist_usage_data" : [],
    "measure_timepoints":[],
    "hist_measure_timepoints":[],
    "total_trial" : null,
    "added": false,
    'endpoint_context': "", 
    'user_duration':[],   
    'selected_modality': '',
    "details": [],
  }
  const [addActivityModal, setAddActivityModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(initialEndpoint)

  const handleToggleActivity = ( evt, flag) => { 
    let newSelectedData = [...props.newEndpoint.endpointAdded]
   
    newSelectedData.push(Object.assign( evt, { added: true, endpoint_type: evt.endpoint_type, selected_modality: null,}))

    setEndpointAdded(newSelectedData)
    props.updateEndpoints({
      endpointAdded: newSelectedData, 
    });
  }

  const [addInsightItem, setAddInsightsItem] = useState(null)
  const handleDetailUpdate = (value) => { 
    removeInsightEvent(addInsightItem)
    handleToggleActivity(value, 'add')
    setAddActivityModal(false);
    setSelectedActivity(initialEndpoint);
    setAddInsightsItem(null)
  }

    return ( 
      <div className="endpoints-library-container">
        <Row className="endpoints-actions-container">
          <Col span={endpointPanelStatus ? 18 : 23} className="left-content-container" style={{paddingRight: '2%'}}>
            <div className="scenarios-heading-left"></div>
            <Collapse activeKey={endPointsActiveKey} onChange={endpointsCallback} className="pd-cost-chart-wrapper" expandIconPosition="right" >
                <Panel header={<span style={{fontSize:'26px'}}>Scenario impact summary</span>} key="1" forceRender={false} >
                    <Row className="summary-container">
                      <Col span={11} className="chart-wrapper">
                          <div className="chart-header">
                              <div className="title"> Endpoints at a glance </div>
                              <div className='chart-container  glance-chart'>
                                <div className='left-part'>
                                  <p className='item-wrapper-top-para'>Number of primary endpoints</p>
                                  <div className='item-wrapper item-wrapper-top'>
                                    <div className='number'>
                                      {roundToWholeNumber(
                                        EndpointByAtGlance?.endpoint_at_glance?.primary_endpoint_scenario ?? 0
                                      )}
                                    </div>
                                    <div className='text'> In this trial </div>
                                  </div>
                                  <div className='item-wrapper item-wrapper-bottom'>
                                    <div className='number'>
                                      {roundToWholeNumber(
                                        EndpointByAtGlance?.endpoint_at_glance?.primary_endpoint_hist ??
                                          0
                                      )}
                                    </div>
                                    <div className='text'> Median in similar historical trials </div>
                                  </div>
                                </div>
                                <div className='middle'> </div>
                                <div className='left-part'>
                                  <p className='item-wrapper-top-para'>Number of secondary endpoints</p>
                                  <div className='item-wrapper item-wrapper-top'>
                                    <div className='number'>
                                      {roundToWholeNumber(
                                        EndpointByAtGlance?.endpoint_at_glance?.secondary_endpoint_scenario ?? 0
                                      )}
                                    </div>
                                    <div className='text'> In this trial </div>
                                  </div>
                                  <div className='item-wrapper item-wrapper-bottom'>
                                    <div className='number'>
                                      {roundToWholeNumber(
                                        EndpointByAtGlance?.endpoint_at_glance?.secondary_endpoint_hist ?? 0
                                      )}
                                    </div>
                                    <div className='text'> Median in similar historical trials </div>
                                  </div>
                                </div>
                                <div className='middle'> </div>
                                <div className='left-part'>
                                  <p className='item-wrapper-top-para'>Unique primary endpoint entities</p>
                                  <div className='item-wrapper item-wrapper-top'>
                                    <div className='number'>
                                      {formatWithCommas(Math.round(
                                        EndpointByAtGlance?.endpoint_at_glance?.unique_count_primary_endpoint ?? 0
                                      ))}
                                    </div>
                                    <div className='text'> In this trial </div>
                                  </div>
                                  <div className='item-wrapper item-wrapper-bottom'>
                                    <div className='number'>
                                      {roundToWholeNumber(
                                        EndpointByAtGlance?.endpoint_at_glance?.unique_primary_endpoint_hist ?? 0
                                      )}
                                    </div>
                                    <div className='text'> Median in similar historical trials </div>
                                  </div>
                                </div>
                                <div className='middle'> </div>
                                <div className='left-part'>
                                  <p className='item-wrapper-top-para'>Unique secondary endpoint entities </p>
                                  <div className='item-wrapper item-wrapper-top'>
                                    <div className='number'>
                                      {roundToWholeNumber(
                                        EndpointByAtGlance?.endpoint_at_glance?.unique_count_secondary_endpoint ?? 0
                                      )}
                                    </div>
                                    <div className='text'> In this trial </div>
                                  </div>
                                  <div className='item-wrapper item-wrapper-bottom'>
                                    <div className='number'>
                                      {roundToWholeNumber(
                                        EndpointByAtGlance?.endpoint_at_glance?.unique_secondary_endpoint_hist ?? 0
                                      )}
                                    </div>
                                    <div className='text'> Median in similar historical trials </div>
                                  </div>
                                </div>
                              </div>
                          </div>
                      </Col> 
                      <Col span={11} className="chart-wrapper">
                          <div className="chart-header">
                              <div className="title"> Patient burden and cost by endpoint type </div>
                              <div className="chart-container cost-chart"> 
                                <Row>
                                  <Col span={24}>
                                    <ReactECharts option={costEndpointOption}></ReactECharts>
                                  </Col>
                                </Row> 
                            </div>
                          </div>
                      </Col> 
                    </Row>
                    <Row>
                      <Col span={24} style={{backgroundColor:'#FBEBD3', color: '#A65728', width: '100%', padding: '1%'}}>
                      Metrics are being calculated for a simulated SoA based on your endpoint selections. Please populate the SoA section for an exact breakdown of patient burden and cost
                      </Col>
                    </Row>
                </Panel>
            </Collapse>

            <Row className="table-container">
              <Col span={24} className="container-top">
                <div className="scenarios-heading-left">
                  <span>Endpoints</span>
                </div>
                <div className="scenarios-heading-right">
                  <div className='btn-scenarios-container-header'> 
                    <Button className="ie-btn" style={{zIndex: 1}} onClick={showEndpointPage}> 
                      <PlusCircleOutlined className="ie-activity-icon" /> Add endpoint
                    </Button>
                    <Button type="primary" 
                    className="save_ie_btn" 
                    style={{zIndex: 1}}
                    onClick={saveEndpoint} 
                    disabled={readOnly} 
                    > Save </Button>
                  </div>
                </div>
              </Col>

              <Col span={24} className="event-dashboard" style={{ height: "700px", overflowX: "scroll", overflowY: "scroll" }}>
              <div className="collapse-inner">
                <div className="criteria-list">
                  <div className="list-columns">
                    <Row>
                        <Col span={5}><div className="col-item">Measure</div></Col>
                        <Col span={5}><div className="col-item">Context</div></Col>
                        <Col span={2}><div className="col-item">DCT</div></Col>
                        <Col span={3}><div className="col-item" style={{paddingRight: 10}}>Primary endpoint <br/>frequency</div></Col>
                        <Col span={3}><div className="col-item">Secondary endpoint <br/>frequency</div></Col>
                        <Col span={4}><div className="col-item">Measure timepoints</div></Col>
                        <Col span={2}><div className="col-item">Actions</div></Col>
                    </Row>
                  </div>
                </div>
                <div className="sectionPanel">
                <EditEndpointsTable 
                 tableIndex={1}
                 panelHeader={"Primary"} 
                 style={{backgroundColor: 'red'}}/>
                 <EditEndpointsTable 
                  tableIndex={2}
                 panelHeader={"Secondary"} />
                 <EditEndpointsTable 
                  tableIndex={3}
                 panelHeader={"Exploratory"} />
              </div>
              </div>  
              
            </Col> 
            </Row>
          </Col>


          <Col span={endpointPanelStatus ? 6: 1} className="right-insight-container"
         >
          <Row>
            {eventPanel==="2"&&(
            <Col span={21} className="left-insight" style={{
              backgroundColor: '#F8F8F8'
            }}>
              <Row style={{backgroundColor: '#F8F8F8'}}>
                <Col span={24}>
                  <div className="item-header">
                    <span>Insights</span>
                  </div>
                </Col>
                <Col span={24} className="content-outer insight-box-wrapper">
                  { insightEvent && filterAddedInsights(insightEvent).filter((item)=>{
                    return item.insight_type === 'endpoint_high_frequency'
                  }).slice(0, 3).map((o) => {
                    return o.action === "ADD" ? (
                      <div className="insight-box">
                        <div className="head">Suggested to add</div>
                        <div className="content">The {o.endpoint_type.toLowerCase()} endpoint <b>{o.endpoint_std_term}</b> occurs in <b>{Math.round(o.frequency * 10000) / 100 + "%"}</b> of similar trials. Consider adding it to your scenario.</div>
                        <div className="button-area">
                          <span className="button-left" onClick={e=>onInsightClick(o)}>
                            <PlusOutlined style={{margin:"0 3px 0 0"}}/> Add endpoint
                          </span>
                          <span className="button-right" onClick={e=>onDismiss(o)}>
                            <DeleteOutlined style={{margin:"0 3px 0 0"}} /> Dismiss
                          </span>
                        </div>
                      </div>
                    ):
                    (
                      <div className="insight-box">
                        <div className="head">Suggested to remove</div>
                        <div className="content">The {o.endpoint_type.toLowerCase()} endpoint <b>{o.endpoint_std_term}</b> occurs in <b>{Math.round(o.frequency * 10000) / 100 + "%"}</b> of similar trials. Consider removing it from your scenario.</div>
                        <div className="button-area">
                          <span className="button-left" onClick={e=>onInsightClick(o)}>
                            <MinusOutlined style={{margin:"0 3px 0 0"}}/> Remove endpoint
                          </span>
                          <span className="button-right" onClick={e=>onDismiss(o)}>
                            <DeleteOutlined style={{margin:"0 3px 0 0"}} /> Dismiss
                          </span>
                        </div>
                      </div>
                    )
                  })}
                  { insightEvent && filterAddedInsights(insightEvent).filter((item)=>{
                    return item.insight_type === 'endpoint_low_frequency'
                  }).slice(0, 3).map((o) => {
                    return o.action === "ADD" ? (
                      <div className="insight-box">
                        <div className="head">Suggested to add</div>
                        <div className="content">The {o.endpoint_type.toLowerCase()} endpoint <b>{o.endpoint_std_term}</b> occurs in <b>{Math.round(o.frequency * 10000) / 100 + "%"}</b> of similar trials. Consider adding it to your scenario.</div>
                        <div className="button-area">
                          <span className="button-left" onClick={e=>onInsightClick(o)}>
                            <PlusOutlined style={{margin:"0 3px 0 0"}}/> Add endpoint
                          </span>
                          <span className="button-right" onClick={e=>onDismiss(o)}>
                            <DeleteOutlined style={{margin:"0 3px 0 0"}} /> Dismiss
                          </span>
                        </div>
                      </div>
                    ):
                    (
                      <div className="insight-box">
                        <div className="head">Suggested to remove</div>
                        <div className="content">The {o.endpoint_type.toLowerCase()} endpoint <b>{o.endpoint_std_term}</b> occurs in <b>{Math.round(o.frequency * 10000) / 100 + "%"}</b> of similar trials. Consider removing it from your scenario.</div>
                        <div className="button-area">
                          <span className="button-left" onClick={e=>onInsightClick(o)}>
                            <MinusOutlined style={{margin:"0 3px 0 0"}}/> Remove endpoint
                          </span>
                          <span className="button-right" onClick={e=>onDismiss(o)}>
                            <DeleteOutlined style={{margin:"0 3px 0 0"}} /> Dismiss
                          </span>
                        </div>
                      </div>
                    )
                  })}
                  { insightEvent && filterAddedInsights(insightEvent).filter((item)=>{
                    return item.insight_type === 'endpoint_modality'
                  }).slice(0, 3).map((o) => {
                    return o.action === "ADD" ? (
                      <div className="insight-box">
                        <div className="head">Reconsider endpoint</div>
                        <div className="content">The {o.endpoint_type.toLowerCase()} endpoint <b>{o.endpoint_std_term}</b> can only be performed via the {o.modality.includes(' and ') ? `modalities` : `modality`} <b>{o.modality}</b>. Consider whether alternative endpoints may enable more non-clinic visits.</div>
                        <div className="button-area">
                          <span className="button-left" onClick={e=>onInsightClick(o)}>
                            <PlusOutlined style={{margin:"0 3px 0 0"}}/> Add endpoint
                          </span>
                          <span className="button-right" onClick={e=>onDismiss(o)}>
                            <DeleteOutlined style={{margin:"0 3px 0 0"}} /> Dismiss
                          </span>
                        </div>
                      </div>
                    ):
                    (
                      <div className="insight-box">
                        <div className="head">Reconsider endpoint</div>
                        <div className="content">The {o.endpoint_type.toLowerCase()} endpoint <b>{o.endpoint_std_term}</b> can only be performed via the {o.modality.includes(' and ') ? `modalities` : `modality`} <b>{o.modality}</b>. Consider whether alternative endpoints may enable more non-clinic visits.</div>
                        <div className="button-area">
                          <span className="button-left" onClick={e=>onInsightClick(o)}>
                            <MinusOutlined style={{margin:"0 3px 0 0"}}/> Remove endpoint
                          </span>
                          <span className="button-right" onClick={e=>onDismiss(o)}>
                            <DeleteOutlined style={{margin:"0 3px 0 0"}} /> Dismiss
                          </span>
                        </div>
                      </div>
                    )
                  })}
                </Col>
              </Row>
            </Col>
            )}
            <Col span={1} className="right-icon" style={{maxWidth: '50px', minWidth: '50px', background: '#FFFFFF'}}>
              <div className={`side-toolbar ${eventLib > 0 ? '' : ''}`}> 
              <Badge style={{marginTop: '20px'}} count={props.newEndpoint.endpointInsightEvent? props.newEndpoint.endpointInsightEvent.length:0 } showZero={props.newEndpoint.endpointInsightEvent && props.newEndpoint.endpointInsightEvent.length === 0 ? true : false }>
                <Tooltip placement="right" title={'Insights'}>
                  {eventPanel==="2"&&(
                    <CarryOutFilled style={{color:"#404042", fontSize: "18px", marginLeft: "15px", marginTop: "20px", paddingTop: "12px", cursor: "pointer"}} onClick={()=> {
                      setEventPanel("1"); endpointInsightsToggleHandler(false)
                    }}/>
                  )}
                  {eventPanel==="1"&&(
                    <CarryOutFilled style={{color:"#999999", fontSize: "18px", marginLeft: "15px", marginTop: "20px", paddingTop: "12px", cursor: "pointer"}} onClick={()=> {
                      setEventPanel("2")
                      endpointInsightsToggleHandler(true)
                    }}/>
                  )}
                </Tooltip>
                </Badge>
                {!endpointPanelStatus &&  <div className="action-wrapper"></div>} 
              </div>
            </Col>
          </Row> 
        </Col>
           
        </Row>
        <EndpointDetails
          whetherModal = {addActivityModal}
          selectedData = {selectedActivity}
          handleDetailUpdate = {handleDetailUpdate}
          isBuilderTable={false}
        /> 
      </div> 
    )
}

const mapDispatchToProps = (dispatch) => ({
  createTrial: (val) => dispatch(createActions.createTrial(val)),
  updateEndpoints: (val) => dispatch(createActions.updateEndpoints(val))
});

const mapStateToProps = (state) => ({
newTrial: state.trialReducer,
newEndpoint: state.endpointReducer,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EndpointsLibrary));